/* eslint-disable max-lines */

export const config = {
    name: 'assetHandover-customerGroup',
    selection: true,
    index: false,
    searchFields: [
        {
            name: '客户等级',
            value: 'customerLevelList',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'NEOCRM_CUSTOMER_LEVEL',
            span: 5
        },
        {
            name: '行业大类',
            value: 'industryCategoryList',
            type: 'select',
            options: [],
            isFixed: true,
            multiple: true,
            span: 5
        },
        {
            name: '行业类型',
            value: 'industryTypeName',
            type: 'advanceMulti',
            isFixed: true,
            span: 5,
            advanceConfig: [
                { 'prop': 'industryTypeName', 'value': '行业类型名称' },
                { 'prop': 'industryTypeCode', 'value': '行业类型编码' }
            ],
            tableConfig: [
                { 'prop': 'industryTypeCode', 'value': '行业类型编码' },
                { 'prop': 'industryTypeName', 'value': '行业类型名称', 'displayName': 'industryTypeName' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: `/industry/info/page`,
            method: 'post',
            cbParams: ['industryTypeCode', 'industryTypeName']
        }
    ],
    columns: [
        {
            label: '客户系名称',
            prop: 'customerGroupName',
            width: 200
        },
        {
            label: '客户等级',
            width: 200,
            prop: 'calCustomerLevelCode',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL'
        },
        {
            label: '行业大类',
            width: 150,
            prop: 'industryCategory',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'SYS_SUPPLIER_INDUSTRY'
        },
        {
            label: '行业类型',
            optionsKey: 'SYS_INDUSTRY_TYPE',
            width: 100,
            type: 'slot',
            slot: true,
            editSlot: true,
            prop: 'industryType'
        },
        {
            label: '承接人',
            prop: 'receiverName',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 100,
            fixed: 'right'
        }
    ]
};
